import { ReactionType } from "../types/socialJournal";
import thumbsUp from "../assets/icons/thumbsUp.svg";
import love from "../assets/icons/love.svg";
import insightful from "../assets/icons/insightful.svg";
import clap from "../assets/icons/clap.svg";
import smile from "../assets/icons/smile.svg";
import fire from "../assets/icons/fire.svg";

// Backend reaction type mapping (using ReactionType strings instead of emojis)
export const BACKEND_TO_REACTION_MAP: Record<string, ReactionType> = {
  thumbsUp: "thumbsUp",
  love: "love",
  insightful: "insightful",
  clap: "clap",
  smile: "smile",
  fire: "fire",
};

export const REACTION_TO_BACKEND_MAP: Record<ReactionType, string> = {
  thumbsUp: "thumbsUp",
  love: "love",
  insightful: "insightful",
  clap: "clap",
  smile: "smile",
  fire: "fire",
};

// SVG icon mapping for frontend display
export const REACTION_ICONS: Record<ReactionType, string> = {
  thumbsUp: thumbsUp,
  love: love,
  insightful: insightful,
  clap: clap,
  smile: smile,
  fire: fire,
};


/**
 * Transform frontend PostData to backend CreatePostData format
 */
export function transformPostDataToCreatePost(
  content: string,
  feeling: string,
  images: string[] = [],
  visibility: "followers" | "private" = "followers"
) {
  const templateType =
    images.length > 0 ? (content ? "mixed" : "image") : "plain";

  return {
    description: content,
    template_type: templateType,
    visibility,
    feelings: feeling,
    images,
  };
}
